import { render, staticRenderFns } from "./ParcelList.vue?vue&type=template&id=5965b176"
import script from "./ParcelList.vue?vue&type=script&lang=js"
export * from "./ParcelList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports